import buildQuery from "odata-query";

import axiosDmsInstance from './axiosDmsInstance';
import { fetchOdataAll } from '../../common/odataUtil';
import { handleApiError } from '../../common/util';
import { IBranch } from '../../models/dms/branch.model';

export const getBranchesAll = async () => {
  try {
    const url = `/api/system/branch/v2/list`;
    const params = {
      '$inlinecount': 'allpages',
    };

    let filter = {
      and: []
    } as { and: any[]; };

    let orderBy = ['Name'];

    const query = buildQuery({ filter: filter, orderBy });
    const response = await fetchOdataAll<IBranch>(axiosDmsInstance, `${url}/${query}`, params);

    return response.data;
  } catch (err: any) {
    return handleApiError('getBranchesAll', err);
  }
};